import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=5fbccf3d&scoped=true&"
import script from "./EditTag.vue?vue&type=script&lang=ts&"
export * from "./EditTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbccf3d",
  null
  
)

export default component.exports